import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    AppBar, Toolbar, Avatar, Typography, IconButton, Switch, CircularProgress, Pagination, Modal, TextField
} from '@mui/material';
import {Add} from '@mui/icons-material';
import HeaderAvatar from "../components/HeaderAvatar";
import {
    addCompanyMember, addScaenario, fetchProject, fetchScenario,
    getScenarios
} from '../services/api';
import {usePermissions} from "../components/PermissionsContext";
import {Scenario} from "../services/types";
import Icon from "../components/Icon";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import PresentationEditor from "../components/PresentationEditor";
import ScenarioEditor from "../components/ScenarioEditor";

const Scenarios: React.FC = () => {
    const { permissions } = usePermissions();
    const [scenarios, setScanarios] = useState<Scenario[]>([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(true);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [totalElements, setTotalElements] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams();
    const [createName, setCreateName] = useState('');
    const [currentScenario, setCurrentScenario] = useState<Scenario | null>(null);


    useEffect(() => {
        loadScenarios();
    }, [page]);

    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        if (id) {
            fetchScenario(id).then(setCurrentScenario);
        }else{
            setCurrentScenario(null)
        }
    }, [id]);

    const loadScenarios = async () => {
        setLoading(true)
        try {
            const data = await getScenarios(page, 10);
            setScanarios(data.items);
            setTotalPages(data.total_pages);
            setTotalElements(data.total);
            setLoading(false)
        } catch (error) {
            console.error('Error fetching team members:', error);
            setError('Failed to load team members');
            setLoading(false)
        }
    };

    const handlePageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
        setPage(newPage);
        setSearchParams({ page: newPage.toString() });
    };

    const handleScenarioClick = (scenario: Scenario) => {
        setCurrentScenario(scenario);
        navigate(`/scenarios/${scenario.id}`);
    };

    const handleCreate = async () => {
        try {
            const addData = {
                name: createName,
                brand_id: "c90c769d-7ecd-4f93-913c-165606e0548b"
            }
            await addScaenario(addData);
            setIsCreateModalOpen(false);
            setCreateName('');
            loadScenarios();
        } catch (error) {
            console.error('Error inviting team member:', error);
            setError('Failed to send invitation');
        }
    };

    return (
        <Box>
            <AppBar className={loading ? 'headerBlock preloading' : 'headerBlock'} position="static">
                <Toolbar className='toolbar'>
                    <Box className='toolbarTitle'>
                        {currentScenario ?
                            <Box>{currentScenario.name}</Box>
                            :
                            <Box>Сценарии <span>{totalElements}</span></Box>
                        }
                    </Box>
                    <Button className="addToobarBtn" variant="contained" onClick={() => {}}><Add /></Button>
                    <HeaderAvatar/>
                </Toolbar>
            </AppBar>



            {!currentScenario ? (
                <Box>
                    <Box className='topButtonsContainer hideMPageButtons'>
                        <Box>Бренд: <b>Abbott</b></Box>
                        <Button className='topButtonsAdd' variant="outlined" onClick={() => setIsCreateModalOpen(true)}><Add /> Добавить сценарий</Button>
                    </Box>
                    {!loading && (

                        <Box className='scenarioList'>
                            {scenarios.map((item) => (
                                <Box className='scenarioItem' key={item.id} sx={{ display: 'flex', alignItems: 'center', mt: 2 }} onClick={() => handleScenarioClick(item)}>
                                    <Box sx={{ flexGrow: 1 }} className='scenarioItemTitle'>{item.name}</Box>
                                </Box>
                            ))}
                        </Box>
                    )}
                </Box>
                // <PresentationsList presentations={presentations} onPresentationClick={handlePresentationClick} />
            ) : (
                <ScenarioEditor
                    scenario={currentScenario}
                />
            )}



            {(totalElements === 0 && !loading) && (
                <Box className='notFoundElements'>
                    <Typography>Сценарии не найдены</Typography>
                </Box>
            )}
            {loading && (
                <Box className='notFoundElements'>
                    <CircularProgress/>
                </Box>
            )}

            {(totalPages > 1 && !loading) && (
                <Pagination className='paginationElement' count={totalPages} page={page} onChange={handlePageChange} />
            )}

            {/* Модальное окно добавления */}
            <Modal open={isCreateModalOpen} onClose={() => setIsCreateModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600 }}>
                        <Typography variant="h6">Создание сценария</Typography>
                        <TextField
                            label="Название"
                            value={createName}
                            onChange={(e) => setCreateName(e.target.value)}
                            fullWidth
                            type="text"
                            margin="normal"
                        />
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Button className="blueModalButton" variant="contained" onClick={handleCreate}>
                                Создать
                            </Button>
                            <Button className="blueModalButton" variant="outlined" onClick={()=>setIsCreateModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
};

export default Scenarios;
